import { Box } from '@mui/material'
import { useTranslation } from 'next-i18next'
import { useContext } from 'react'
import CartShoppingIcon from 'assets/icons/nucleo/18px_cart-shopping.svg'
import { CartContext } from 'components/Hook/CartContext'
import {
  CartItemsCount,
  CartItemsCountValue,
  minWidthIcon
} from 'components/Layout/Header/Header.style'
import { LinkButton } from 'components/LinkButton'
import { CartUtils } from 'services/api/utils/CartUtils'

interface CartButtonProps {
  withLabel?: boolean
  fullWidthOnMobile?: boolean
}

export const CartButton = ({
  withLabel,
  fullWidthOnMobile
}: CartButtonProps) => {
  const { cart } = useContext(CartContext)
  const { t } = useTranslation('common')
  const cartItemsCount = cart ? cart.items.filter(CartUtils.isBib).length : 0

  return (
    <Box position="relative" width={fullWidthOnMobile ? '100%' : 'auto'}>
      <LinkButton
        prefetch={false}
        leftIcon={withLabel ? <CartShoppingIcon /> : undefined}
        label={withLabel ? t('menu.cart') : undefined}
        icon={withLabel ? undefined : <CartShoppingIcon css={minWidthIcon} />}
        href={`/checkout/cart${cart ? `?cartId=${cart.id}` : ''}`}
        passHref
        fullWidthOnMobile={fullWidthOnMobile}
        aria-label={t('menu.cart')}
      />
      {cartItemsCount > 0 && (
        <CartItemsCount>
          <CartItemsCountValue>{cartItemsCount}</CartItemsCountValue>
        </CartItemsCount>
      )}
    </Box>
  )
}
